import {
    BannersEditMassActions,
    ON_ACCEPT_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_LINK_CREATIVE_BULK_REPLACEMENT_EDITOR,
    SAVE_MASS_ACTIONS_LINK_CREATIVE_BULK_REPLACEMENT_EDITOR
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { BannersEditMassActionsState } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsLinkCreativeReplaceReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case SAVE_MASS_ACTIONS_LINK_CREATIVE_BULK_REPLACEMENT_EDITOR:
            return bannersEditMassActionsInitialState;
        case ON_ACCEPT_MASS_ACTIONS_LINK_BULK_REPLACEMENT_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    errors: [],
                    inProgress: true
                }
            };
        case OPEN_MASS_ACTIONS_LINK_CREATIVE_BULK_REPLACEMENT_EDITOR: {
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        linkCreativeBulkReplacementEditorVisible: true
                    },
                    data: {
                        ...state[action.massActionId].data,
                        creativeAdIds: action.creativeAdIds
                    }
                }
            };
        }
        default:
            return state;
    }
}
